export default "__VITE_ASSET__BLLTUjP$__"